import { lazy } from 'react';
import { RouteObject } from 'react-router';

// Lazy load guards and layouts
const HasToBeClientGuard = lazy(() =>
  import('app/core/guards/HasToBeClientGuard').then((m) => ({ default: m.default || m.HasToBeClientGuard })),
);
const HasToBeLoggedInGuard = lazy(() => import('app/core/guards/HasToBeLoggedInGuard'));
const DefaultLayout = lazy(() => import('app/core/layout/DefaultLayout'));
const Error404Page = lazy(() => import('app/main/errors/Error404Page'));

// Lazy load page components
const StepsLayout = lazy(() => import('../../../../main/elevators/steps/layout/StepsLayout'));
const CreateNewProject = lazy(() => import('../../../../main/elevators/create-new-project/CreateNewProject'));

const Step1 = lazy(() => import('../../../../main/elevators/steps/step1/Step1'));

const Step2 = lazy(() => import('../../../../main/elevators/steps/step2/Step2'));

const ProjectSummary = lazy(() => import('../../../../main/elevators/steps/project-summary/ProjectSummary'));

const Projects = lazy(() => import('../../../../main/elevators/projects/Projects'));

const Certificates = lazy(() => import('../../../../main/elevators/certificates/Certificates'));

const Inspections = lazy(() => import('../../../../main/elevators/inspections/Inspections'));

const Invitations = lazy(() => import('../../../../main/elevators/invitations/Invitations'));

const ProjectDetails = lazy(() => import('../../../../main/elevators/projects/project-details/ProjectDetails'));

const EquipmentDetails = lazy(() => import('../../../../main/elevators/projects/equipment-details/EquipmentDetails'));

const ReportDetails = lazy(() => import('../../../../main/elevators/report-details/ReportDetails'));

const PaymentRequestPay = lazy(
  () => import('../../../../main/elevators/payments/inspections-payment/InspectionsPayment'),
);

const PaymentRequestReceipt = lazy(
  () => import('../../../../main/elevators/payments/inspections-payment-receipt/InspectionsPaymentReceipt'),
);
const CertificatesPaymentCreate = lazy(
  () => import('../../../../main/elevators/payments/certificate-payment/CertificatesPaymentCreate'),
);

const CertificatePay = lazy(
  () => import('../../../../main/elevators/payments/certificate-payment/CertificatesPayment'),
);

const PREFIX = '/elevators';

export const clientElevatorsRoutes: RouteObject[] = [
  {
    path: PREFIX,
    element: (
      <HasToBeLoggedInGuard>
        <HasToBeClientGuard>
          <DefaultLayout />
        </HasToBeClientGuard>
      </HasToBeLoggedInGuard>
    ),
    errorElement: <Error404Page />,
    children: [
      {
        path: 'create-project',
        element: (
          <StepsLayout>
            <CreateNewProject />
          </StepsLayout>
        ),
      },
      {
        path: 'projects/:id/step/1',
        element: (
          <StepsLayout>
            <Step1 />
          </StepsLayout>
        ),
      },
      {
        path: 'projects/:id/step/2',
        element: (
          <StepsLayout>
            <Step2 />
          </StepsLayout>
        ),
      },
      {
        path: 'projects/:id/step/3',
        element: (
          <StepsLayout>
            <ProjectSummary />
          </StepsLayout>
        ),
      },
      {
        path: 'projects/:id',
        element: <ProjectDetails />,
      },
      {
        path: 'equipment/:equipmentId',
        element: <EquipmentDetails />,
      },
      {
        path: 'projects',
        element: <Projects />,
      },
      {
        path: 'certificates',
        element: <Certificates />,
      },
      {
        path: 'inspections',
        element: <Inspections />,
      },
      {
        path: 'invitations',
        element: <Invitations />,
      },
      {
        path: 'report/:id',
        element: <ReportDetails />,
      },
      {
        path: 'projects/:id/payment-request/:paymentRequestId',
        element: <PaymentRequestPay />,
      },
      {
        path: 'projects/:id/payment-request/:paymentRequestId/receipt',
        element: <PaymentRequestReceipt />,
      },
      {
        path: 'projects/:id/certificates-payment',
        element: <CertificatesPaymentCreate />,
      },
      {
        path: 'projects/:id/certificates-payment/:paymentRequestId',
        element: <CertificatePay />,
      },
    ],
  },
];
